import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveLeftUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.914 4.2 3.6 9.514m0 0 5.314 5.314M3.6 9.514h12.8a4 4 0 0 1 4 4V19.8"
    />
  </svg>
);
export default SvgArrowCurveLeftUp;
